import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Define an action creator using createAsyncThunk
export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async () => {
    const response = await axios.get(
      "https://marshall-wears-backend-z2mi.onrender.com/api/3zRnG9yQ8pX4eJ7T/all-products"
    );
    return response.data;
  }
);

// Define a slice of state using createSlice
const productsSlice = createSlice({
  name: "products",
  initialState: { products: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.products = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// Export the slice reducer and actions
export default productsSlice.reducer;
